// extracted by css-extract-rspack-plugin
export default {"thumb":"thumb-g10CIQ","square":"square-DIXeVD","fallback":"fallback-h_BbTX","corner":"corner-brmtVU"};